import styled from "styled-components";
import { colors } from "styles";

const Bar = styled.div`
  position: relative;
  background-color: ${colors.white};
  width: 100%;
  height: 7px;
  overflow: hidden;

  &:after {
    content: "";
    display: block;
    position: absolute;
    width: ${(props) => `${props.value}%`};
    height: 100%;
    left: 0;
    top: 0;
    background-color: ${colors.blue};
    transition: all 300ms ease-in-out;
  }
`;

const ProgressBar = ({ value }) => {
  return <Bar value={value} />;
};

export default ProgressBar;
